export default __webpack_public_path__ + "static/media/007-bracelet.99b81d0a.svg";